//Type Constants
import {
    REQUEST_GET_ROLERIGHTS, SUCCESS_GET_ROLERIGHTS, ERROR_GET_ROLERIGHTS,
    REQUEST_EDIT_ROLERIGHTS, SUCCESS_EDIT_ROLERIGHTS, ERROR_EDIT_ROLERIGHTS
} from 'typeConstants';


//Initial State
import { roleRights as initialState } from '../../initialState.tsx';

const roleRights = (state = initialState, action) => {
    switch(action.type) {
        case REQUEST_GET_ROLERIGHTS:
        return {
            ...state,
            fetchingRoleRights: true,
        };
        case SUCCESS_GET_ROLERIGHTS:
        return {
            ...state,
            roleRightsViewModel: action.payload,
            fetchingRoleRights: false,
        };
        case ERROR_GET_ROLERIGHTS:
        return {
            ...state,
            fetchingRoleRights: false
        };
        case REQUEST_EDIT_ROLERIGHTS:
        return {
            ...state,
            requestedRoleRightsEdit: true,
        };
        case SUCCESS_EDIT_ROLERIGHTS:
        return {
            ...state,
            requestedRoleRightsEdit: false,
        };
        case ERROR_EDIT_ROLERIGHTS:
        return {
            ...state,
            requestedRoleRightsEdit: false
        };
        default:
        return state;
    }
};
export default roleRights;

